module.exports = __webpack_public_path__ + "static/img/91BM-058-HelenYan.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-058-HelenYan.jpg
// module id = BYkb
// module chunks = 0